import styled from 'styled-components';

export const StyledFootnoteHeading = styled.h4`
  ${({ theme: { fonts, fontWeights } }) => `
    font-family: ${fonts.display};
    font-weight: ${fontWeights.semiBold};
    margin-bottom: .75rem;
  `}
`;
